<template>
    <div class="columns is-multiline">
      <div class="column">
        <div class="content">
          <dl>
            <dt>Trailer</dt>
            <dd> {{ equipment.companyJobTrailerType }} </dd>
          </dl>
        </div>
      </div>

      <div class="column">
        <div class="content">
          <dl>
            <dt>Straps</dt>
            <dd> {{ equipment.companyJobStrapCount }} </dd>
          </dl>
        </div>
      </div>

      <div class="column">
        <div class="content">
          <dl>
            <dt>Minimum Insurance</dt>
            <dd> {{ formattedInsurance }} </dd>
          </dl>
        </div>
      </div>

      <div class="column is-full">
        <div class="content">
          <dl>
            <dt>Comments</dt>
            <dd> {{ equipment.companyJobEquipmentComments }} </dd>
          </dl>
        </div>
      </div>
    </div>
</template>

<script>
import Numeral from 'numeral'
export default {
  name: 'EquipmentInformation',
  props: {
    equipment: {
      type: Object,
      required: true
    }
  },

  computed: {
    formattedInsurance() {
      return Numeral(this.equipment.companyJobInsuranceCoverageMinimum).format('$0,0.00')
    }
  }
}
</script>

<style scoped>
</style>
